<template>
    <v-layout class="backButton pr-3" v-on:click="goBack">
        <v-icon class="mr-2" color="indigo_5">fas fa-arrow-left</v-icon>
        <span class="backButton__text">Назад</span>
    </v-layout>
</template>

<script>
export default {
    name: 'backButton',

    data: () => ({}),

    methods: {
        goBack() {
            this.$router.go(-1);
        },
    },
};
</script>

<style lang="scss" scoped>
@import '@/style/global.scss';

.backButton {
    cursor: pointer;
    width: 90px;

    &__text {
        color: #547685;
        display: inline;
        font-family: 'Fira Sans', sans-serif;
        font-size: 16px;
        font-weight: 500;
    }
}
</style>
